import { useEffect } from "react";
import axios from "axios";

const VAPID_PUBLIC_KEY = "BHg0ZK9BgPgba-MzacVAGccYAV_S15YAv3k5vcCAMCZTf-iXRAJGftMhVz77f4YT3lLVm7-3C5ThRkhrA3wS5f4";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}
export default function usePushNotifications(userId) {
    useEffect(() => {
      if (!userId) return;
  
      // ✅ ADD IT HERE (FIRST THING INSIDE EFFECT)
      if (localStorage.getItem("push_registered") === userId) return;
  
      const registerPush = async () => {
        try {
          if (!("serviceWorker" in navigator)) return;
  
          const permission = await Notification.requestPermission();
          if (permission !== "granted") return;
  
          const registration = await navigator.serviceWorker.register("/service-worker.js");
  
          let subscription = await registration.pushManager.getSubscription();
  
          if (!subscription) {
            subscription = await registration.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
            });
          }
  
          await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/push/subscribe`,
            {
              userId,
              subscription,
            }
          );
  
          // ✅ mark as done ONLY after success
          localStorage.setItem("push_registered", userId);
  
          console.log("Push registered successfully");
        } catch (err) {
          console.error("Push registration failed:", err);
        }
      };
  
      registerPush();
    }, [userId]);
  }